import { useEffect, useState } from "react";
import FeatureLayer from "@arcgis/core/layers/FeatureLayer.js";
import Graphic from "@arcgis/core/Graphic";
import { useAuth } from "../../../../../../../Providers/AuthProvider/AuthProvider";
import config from '../../../../../../Common/config'; // Import your config file
import ClipLoader from "react-spinners/ClipLoader"; // Import ClipLoader
import { RotatingLines } from "react-loader-spinner";
import { useTheme } from "../../../../../ThemeContext/ThemeContext";


export default function PhotoContent({setInputClicked,setIscategory,isDarkMode}) {
  //const [mediaItems, setMediaItems] = useState([]);
  //const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { contextMapView, setPopupSelectedGeo, setIsEditPOI, mediaItems } = useAuth();
  const [featureLayer, setFeatureLayer] = useState(null);
  const [loadedImages, setLoadedImages] = useState({});
  const {isLangArab} = useTheme()

  const handleImageLoad = (id) => {
    setLoadedImages((prevState) => ({
      ...prevState,
      [id]: true,
    }));
  };

  useEffect(() => {
    // const loadAttachments = async () => {
    //   const allMediaItems = []; // Array to store media items from all layers

    //   for (const layerConfig of config.featureServices) {
    //     const layer = new FeatureLayer({
    //       url: layerConfig.url,
    //       outFields: ["*"],
    //     });

    //     try {
    //       const query = layer.createQuery();
    //       query.where = "Isadminapproved!=2";
    //       query.returnGeometry = true;
    //       query.outFields = ["*"];
    //       const results = await layer.queryFeatures(query);

    //       const objectIds = results.features.map(
    //         (feature) => feature.attributes.OBJECTID
    //       );
    //       const attachments = await layer.queryAttachments({ objectIds });

    //       results.features.forEach((feature) => {
    //         const objectId = feature.attributes.OBJECTID;

    //         if (attachments[objectId] && attachments[objectId].length > 0) {
    //           attachments[objectId].forEach((attachment) => {
    //             if (attachment.contentType.startsWith("image/")) {
    //               const mediaItemObject = {
    //                 type: attachment.contentType,
    //                 url: attachment.url,
    //                 objectId: objectId,
    //                 layerName: layerConfig.name,
    //               };
    //               allMediaItems.push(mediaItemObject);
    //             }
    //           });
    //         }
    //       });
    //     } catch (error) {
    //       console.error(
    //         `Error querying layer "${layerConfig.name}" or attachments:`,
    //         error
    //       );
    //     }
    //   }

    //   setMediaItems(allMediaItems); // Store the data in the context
    //   setLoading(false);
    // };

    // loadAttachments();
  console.log(mediaItems);
  }, []);

  const handleImageClick = async (REL_GLOBALID) => {
    setIscategory(false);
    setInputClicked(false);
    
    // Loop through each layer in your config
    for (const selectedLayerConfig of config.featureServices) {
      try {
        // Create a FeatureLayer instance for the selected layer
        const featureLayer = new FeatureLayer({
          url: selectedLayerConfig.url,
          outFields: ["*"] // Include all fields, or specify the necessary ones
        });
  
        // Query the layer for the specific REL_GLOBALID
        const feature = await featureLayer.queryFeatures({
          where: `GlobalID = '${REL_GLOBALID}' and Isadminapproved!=2`,  // Use REL_GLOBALID in query
          outFields: ["*"],
          returnGeometry: true
        });
  
        // Check if any features are found in the current layer
        if (feature.features.length > 0) {
          // Optionally, open a popup with feature info
          const pointGraphic = new Graphic({
            geometry: feature.features[0].geometry,
            symbol: {
              type: "simple-marker", // Customize symbol as needed
              color: [0, 255, 255, 0.5],
              outline: {
                color: [0, 255, 255, 1],
                width: 2
              }
            }
          });
    
          contextMapView.graphics.add(pointGraphic);
  
          // Zoom and center the map on the feature's geometry
          await contextMapView.goTo({
            target: feature.features[0].geometry,
            center: feature.features[0].geometry,  // Centers on the feature's geometry
            zoom: 15  // Set zoom level
          });
          
          setPopupSelectedGeo(feature.features[0]); // Store the selected feature geometry
          setIsEditPOI(true); // Set your state for further editing or interactions
          
          break; // If you find the feature in any layer, stop searching further layers
        } else {
          console.log(`No feature found with REL_GLOBALID: ${REL_GLOBALID} in layer ${selectedLayerConfig.name}`);
        }
      } catch (error) {
        console.error(`Error querying layer ${selectedLayerConfig.name}:`, error);
      }
    }
  };
  

  // if (Array.isArray(mediaItems) && mediaItems.length === 0) {
  //   return (
  //     <div className="flex items-center justify-center   h-full">
  //       <ClipLoader color="#808080" size={40} /> {/* Gray, medium-sized loader */}
  //     </div>
  //   );
  // }

  if (error) {
    return <div>{error}</div>;
  }

  return (
    <div className="p-3 h-[13rem] overflow-y-scroll">
  {!Array.isArray(mediaItems) || mediaItems.length === 0 ? (
    <div className="flex items-center justify-center h-full">
      <p className={`${isDarkMode ? "text-white" : "text-gray-800"} text-sm`}>
       {isLangArab?"لا وسائل الإعلام":"No Media"}
      </p>
    </div>
  ) : (
    <div className="grid grid-cols-3 gap-2">
      {mediaItems
        .filter((item) => {
          const supportedImageTypes = ["image/jpeg", "image/png", "image/gif"];
          return supportedImageTypes.includes(item.type);
        })
        .map((item) => (
          <div
            key={item.objectId}
            className="tab:rounded-lg rounded-md overflow-hidden laptop_s:w-[99%] h-[60px] tab:h-[60px]"
            onClick={() =>
              loadedImages[item.objectId] &&
              handleImageClick(item.REL_GLOBALID)
            }
          >
            {!loadedImages[item.objectId] && (
              <div
                className={`w-full h-full ${
                  isDarkMode ? "bg-white/80" : "bg-gray-800"
                } flex items-center justify-center`}
              >
                <RotatingLines
                  strokeColor={isDarkMode ? "#000000" : "#FBFBFB"} // Change stroke color based on isDarkMode
                  strokeWidth="5"
                  animationDuration="1"
                  width="30"
                  visible={true}
                />
              </div>
            )}

            <img
              src={`${process.env.REACT_APP_API_URL}${item.url}`}
              alt="Media content"
              className={`w-full h-full object-cover block ${item.objectId} `}
              onLoad={() => handleImageLoad(item.objectId)}
              onError={(e) => {
                e.target.src = "/placeholder-image.png";
                e.target.alt = "Unsupported format";
              }}
            />
          </div>
        ))}
    </div>
  )}
</div>

  
  );
}


const images = [
  { imageName: "image1.png" },
  { imageName: "image2.png" },
  { imageName: "image3.png" },
  { imageName: "image4.png" },
  { imageName: "image5.png" },
  { imageName: "image6.png" },
  { imageName: "image7.png" },
  { imageName: "image8.png" },
];